<div *ngIf="auth.isLoading$ | async">Carregando...</div>

<div class="main-container" [class.is-mobile]="mobileQuery.matches">

  <app-header [mobileQuery]="mobileQuery" [sidebarOpened]="opened" (toggleSideBarForMe)="snav.toggle()"
    (toggleSideBarNotificationForMe)="snavNotification.toggle()"></app-header>

  <!-- Container principal com barra lateral -->
  <mat-sidenav-container>
    <!-- Barra lateral principal -->
    <mat-sidenav class="sidenav-menu" [opened]="opened" #snav [mode]="mobileQuery.matches ? 'over' : 'side'"
      [fixedInViewport]="mobileQuery.matches" fixedTopGap="56" (openedChange)="onSidenavOpenedChange($event)">
      <app-sidebar (toggleSideBarForMe)="snav.toggle()"></app-sidebar>
      <div class="version">Versão: {{ appVersion }} - {{ deployDate }}</div>
    </mat-sidenav>

    <!-- Barra lateral de notificações -->
    <mat-sidenav #snavNotification position="end">
      <app-notification (toggleSideBarNotificationForMe)="snavNotification.toggle()"
        [sidebarNotification]="true"></app-notification>
    </mat-sidenav>

    <!-- Conteúdo principal -->
    <mat-sidenav-content>
      <router-outlet></router-outlet>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>